import { AttitudeState, RHRepo } from '@aero-platform/shared'

type CaseLike = { selectedAttitudeState?: AttitudeState; selectedRHRepo?: RHRepo }

/**
 * Re-point the selected cases at a newly chosen attitude set by state name. A matched case takes the
 * new set's state and drops its RH file (the row re-matches it); unselected or unmatched cases are
 * dropped, and unmatched names are reported. Never mutates the inputs.
 */
export const remapCasesToAttitudeSet = <T extends CaseLike>(
  cases: T[],
  selectedNames: string[],
  nextStates: AttitudeState[]
): { cases: T[]; removedNames: string[] } => {
  const selected = new Set(selectedNames || [])
  const removed = new Set<string>()
  const remapped: T[] = []
  ;(cases || []).forEach(caseItem => {
    const stateName = caseItem.selectedAttitudeState?.name || ''
    if (!selected.has(stateName)) return
    const nextState = (nextStates || []).find(state => state.name === stateName)
    if (!nextState) {
      removed.add(stateName)
      return
    }
    remapped.push({
      ...caseItem,
      selectedAttitudeState: { ...nextState },
      selectedRHRepo: undefined
    } as T)
  })
  return { cases: remapped, removedNames: Array.from(removed) }
}
